
import { RemoteGoogle, remoteEnum } from '@/data/source/remote/remoteGoogle'

const baseUrl = 'place/details/json'

const fetchPlaceDetails = (placeId : any, filter: any = '') => new RemoteGoogle(remoteEnum.get, `${baseUrl}?place_id=${placeId}${filter}`)

export {
  fetchPlaceDetails
}